import { PlanCode } from '../../../types/subscription'

export const TEAM_STARTER_PLUS_PLANS = new Set<PlanCode>([
  PlanCode.TEAM_STARTER,
  PlanCode.TEAM_PRO,
  PlanCode.ENTERPRISE,
])
